import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import API_URL from '../constants/environment';

export interface StatusResponse {
    connectionsPct: number;
    platformPct: number;
}

const EMPTY_STATUS: StatusResponse = {
    connectionsPct: 0,
    platformPct: 0,
};

const getStatus = async (): Promise<StatusResponse> => {
    try {
        const { data } = await axios.get<StatusResponse>(`${API_URL}/status`);
        return {
            connectionsPct: data?.connectionsPct ?? 0,
            platformPct: data?.platformPct ?? 0,
        };
    } catch {
        return EMPTY_STATUS;
    }
};

export const useGetStatus = () => {
    return useQuery({
        queryKey: ['status'],
        queryFn: getStatus,
        refetchInterval: 30000,
    });
};
